import { ISiteRegionalSettings } from "../../interfaces/ISiteRegionalSettings";
import { RegionalSettingsState } from "../../types";
import { typedAction } from "../helpers";
import { ADD_REGIONAL_SETTINGS } from "./actionTypes";

const initialState: RegionalSettingsState = {};

export const addRegionalSettings = (regionalSetting: ISiteRegionalSettings) => {
    return typedAction(ADD_REGIONAL_SETTINGS, regionalSetting);
};

type RegionalSettingsAction = ReturnType<typeof addRegionalSettings>;

export const regionalSettingsReducer = (
    state = initialState,
    action: RegionalSettingsAction
): RegionalSettingsState =>  {
    switch (action.type) {
        case ADD_REGIONAL_SETTINGS:
            return { ...state, [action.payload.webUrl]: action.payload };
        default:
            return state;
    }
}